// extracted by mini-css-extract-plugin
module.exports = {"content":"content-7b5584560d40f7d8623df5631d9d8629","mark":"mark-adf8203cd6d1e2e949dd0eaad3e6f2f3"};